module.exports = __webpack_public_path__ + "static/media/debit-card.f19748e5.svg";